export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8000/api';

// 後端存儲 URL（用於圖片等靜態資源）
export const STORAGE_BASE_URL =
  process.env.REACT_APP_STORAGE_BASE_URL ?? 'http://localhost:8000';

export const TOKEN_STORAGE_KEY = 'hitachi_token';
export const USER_STORAGE_KEY = 'hitachi_user';
export const STORE_STORAGE_KEY = 'hitachi_selected_store';

/**
 * 將相對路徑轉換為完整的存儲 URL
 */
export const getStorageUrl = (path: string): string => {
  if (!path) return '';
  
  // 如果已經是完整 URL，直接返回
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // 如果是 blob URL，直接返回
  if (path.startsWith('blob:')) {
    return path;
  }
  
  // 移除開頭的斜線
  const cleanPath = path.replace(/^\//, '');
  
  return `${STORAGE_BASE_URL}/${cleanPath}`;
};

